<template>
  <div class="between_item between_left">
    <card title="实时数据">
      <div class="card_content fb">
        <div class="card_item card_left">
          <div class="data_box fs box1 box_style">
            <div class="icon icon_s"><img src="../../assets/hs/icon_日发电量.png" alt="" /></div>
            <div class="info">
              <p class="num">{{ formartNumber(nowPowerData.electricDay) }}</p>
              <p>日发电量（kW·h）</p>
            </div>
          </div>
          <div class="data_box fs box2 box_style">
            <div class="icon icon_m">
              <img src="../../assets/hs/img_当前发电功率.png" alt="" />
              <p>当前发电功率</p>
            </div>
            <div class="line"></div>
            <div class="info">
              <p class="num">{{ formartNumber(nowPowerData.installedCapacity) }}</p>
              <p>总装机容量(kW)</p>
            </div>
          </div>
          <div class="card_left_foot fb">
            <div class="info box_style">
              <p class="num">{{ nowWaterData.ecologicalFlow }}</p>
              <p>生态流量(m³/s)</p>
            </div>
            <div class="info box_style">
              <p class="num">{{ Math.floor(nowWaterData.frontWaterLevel * 1000) / 1000 }}</p>
              <p>前池水位(m)</p>
            </div>
          </div>
        </div>

        <div class="card_item card_right">
          <div class="data_box fs box5 box_style">
            <div class="icon icon_m">
              <img src="../../assets/hs/img_月发电量.png" alt="" />
              <p>月发电量</p>
            </div>
            <div class="line"></div>
            <div class="info">
              <p class="num">{{ formartNumber(nowPowerData.electricMon) }}</p>
              <p>月已发电量(kW·h)</p>
            </div>
          </div>
          <div class="data_box fs box6 box_style">
            <div class="icon icon_m">
              <img src="../../assets/hs/img_年发电量.png" alt="" />
              <p>年发电量</p>
            </div>
            <div class="line"></div>
            <div class="info">
              <p class="num">{{ formartNumber(nowPowerData.electricYear) }}</p>
              <p>年已发电量(kW·h)</p>
            </div>
          </div>
        </div>
      </div>
      <div class="chart_box box_style">
        <div id="leftChart" ref="cusEchart" class="cus-echart"></div>
      </div>
    </card>

    <card title="故障预测及告警" styles="margin-top: 24px">
      <div class="card_table" id="cardTable">
        <dv-scroll-board ref="warnListTable" :config="tableConfig" @click="clickWarm" />
      </div>
    </card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue';
import * as echarts from 'echarts';
import * as Api from '@/api';
import dayjs from 'dayjs';

import { eleOpHome, waterOp } from './lineData';
export default {
  components: {
    Card,
  },
  props: {
    tableData: Array,
  },
  data() {
    return {
      eleOption: eleOpHome,
      waterOption: waterOp,
      tableConfig: {
        header: ['设备名称', '故障名称', '时间'],
        rowNum: 5,
        data: [],
        headerBGC: 'rgba(3,74,144,0.3)',
        columnWidth: [150, 150, 220],
        align: ['center', 'center', 'center'],
        oddRowBGC: 'rgba(14,36,60,0.4)',
        evenRowBGC: 'rgba(14,36,60,0.8)',
      },
      nowPowerData: {
        detpId: -1,
        detpName: '',
        installedCapacity: 0, //装机容量
        power: -1, //功率
        electricDay: 0, //日发电量
        electricMon: 0, //月发电量
        planMon: 0, //月计划发电量
        electricYear: 0, //年发电量
        planYear: -1, //年计划发电量
        generationDays: [{ date: '2023-12-01', generate: 120, load: 120 }], //近30天发电量曲线   date 日期   generate 发电量   load功率
        generationMons: [{ year: 2023, month: 9, strMonth: '09', power: 120, planPower: 130 }], //当年发电量曲线   power月发电量  planPower  月计划发电量
      },
      nowWaterData: {
        ecologicalFlow: '0',
        frontWaterLevel: '0', //前池水位
      },
      stationOneInfo: {}, //高板岩一站
      RealDataEleMachine: {}, //发电机组实时数据
    };
  },
  mounted() {
    // this.dealMockData();
    this.dataInit();
  },
  methods: {
    dealMockData() {
      const { data: listData } = this.$Mock.stationWarns;
      console.log(listData);
      const curList = [];
      listData.forEach((item, index) => {
        const { ord, name, createTime } = item;
        curList.push([ord, name, createTime]);
      });
      this.tableConfig.data = curList;
    },
    dataInit() {
      // 高板岩一站，取生态流量
      Api.getHydroPower({ deptId: '2000000134083' }).then((res) => {
        console.log('一站信息 :>> ', res);
        if (res.success) {
          this.stationOneInfo = { ...this.stationOneInfo, ...res.data };
        }
      });
      // 高板岩二站
      Api.getHydroPower({ deptId: '2000000134081' }).then((res) => {
        console.log('前池水位信息 :>> ', res);
        if (res.success) {
          this.nowWaterData = { ...this.nowWaterData, ...res.data };
          this.$Storage.set('stationInfo', res.data);
          const { frontCurveMap, powerYearMap } = res.data;
          this.$nextTick(() => {
            this.renderChart(powerYearMap);
          });
        }
      });
      // Api.getBeforeWaterFlow().then((res) => {
      //   console.log('shuiweires :>> ', res);
      //   if (res.success) {
      //     this.nowWaterData = { ...this.nowWaterData, ...res.data };
      //   }
      // });
      Api.getPowerDetail().then((res) => {
        console.log('power :>> ', res);
        if (res.success) {
          this.nowPowerData = { ...this.nowPowerData, ...res.data };
        }
      });
      Api.getStationWarns().then((res) => {
        console.log('warns :>> ', res);
        if (res.success) {
          this.renderTable(res.data);
        }
      });

      // 无实时数据时演示-开始
      // const listQuery = {
      //   current: 1,
      //   size: 20,
      //   display: 1,
      //   stationId: '17230100205',
      // };
      // Api.getFaultList(listQuery).then((res) => {
      //   const { data, code } = res;
      //   if (code == 200) {
      //     this.renderTable(data.records);
      //   }
      // });
      // 无实时数据时演示-结束

      // 获取生态流量
      const flowParam = {
        deviceCode: '15251065',
        col: 'ecological_flow',
        beginSpt: `${dayjs().subtract(1, 'day').format('YYYY-MM-DD HH:')}00:00`,
        endSpt: `${dayjs().format('YYYY-MM-DD HH:')}00:00`,
      };
      Api.getFlowValue(flowParam).then((res) => {
        console.log('res :>> ', res);
        // if (res.success) {
        //   this.nowWaterData.ecologicalFlow =
        //     res.data[0].flow_value == 'null' ? 0 : res.data[0].flow_value;
        // }
      });
      Api.getEcologicalFlowStep1().then((res) => {
        Api.getEcologicalFlowStep2(res.data).then((res2) => {
          if (res2.message == 'success') {
            this.nowWaterData.ecologicalFlow =
              res2.data.records[0].q == 'null' ? 0 : res2.data.records[0].q;
          }
        });
      });
    },
    renderChart(frontCurveMap) {
      const waterChartDataValue = [];
      const waterChartDataKey = [];
      // Object.keys(frontCurveMap).forEach((item) => {
      //   waterChartDataValue.push(frontCurveMap[item]);
      //   waterChartDataKey.push(item);
      // });
      frontCurveMap.forEach((item) => {
        waterChartDataValue.push(item.power);
        waterChartDataKey.push(`${item.month}月`);
      });
      this.eleOption.xAxis.data = waterChartDataKey;
      this.eleOption.yAxis.name = '当年发电量/kWh';
      this.eleOption.series[0].data = waterChartDataValue;
      // 初始化echarts实例
      let myChart = echarts.init(document.getElementById('leftChart'));

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(this.eleOption);
    },
    renderTable(data) {
      const tableData = [];
      for (let i = 0; i < data.length; i++) {
        tableData.push([`${data[i].ord}`, `${data[i].name}`, `${data[i].createTime.substring(5)}`]);
      }
      console.log('tableData :>> ', tableData);
      this.tableConfig['data'] = tableData;

      this.$refs['warnListTable'].updateRows(this.tableConfig.data);
    },
    clickWarm(e) {
      console.log(e);
      // this.$Model.i3DInit();
      // setTimeout(() => {
      //   this.$Model.i3dSinkOff();
      // }, 500);
      setTimeout(() => {
        this.$Model.i3dSinkOpen();
      }, 800);
      this.$Storage.set('warnRowIndex', e.rowIndex); ////当前选择的项的下标，由于组件还未渲染，所以要存一份在storage里面

      this.$bus.$emit('globalTab', '故障诊断');
      this.$bus.$emit('globalTabIndex', 1);
      this.$bus.$emit('warmFromIndex', true);
      this.$Storage.set('warmFromIndex', true); //由于组件还未渲染，所以要存一份在storage里面
    },
    formartNumber(num) {
      if (num >= 10000) {
        var formattedNumber = (num / 10000).toFixed(2) + '万';
        return formattedNumber;
      } else {
        return num.toFixed(2).toString();
      }
    },
  },
  beforeDestroy() {
    this.$Storage.remove('stationInfo');
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.between_item {
  width: 480px;
  &.between_left {
  }
}
.cus-echart {
  width: 100%;
  height: 100%;
}
.card_content {
  .card_item {
    &.card_left {
      .card_left_foot {
        flex: 0 0 auto;
        width: 230px;
        .info {
          flex: 0 0 auto;
          width: 110px;
          height: 64px;
          p {
            padding-left: 15px;
            text-align: left;
          }
          .num {
            font-family: Roboto-Medium, Roboto;
            font-size: 20px;
            color: #fff;
            text-shadow: 0px 0px 4px rgba(83, 143, 209, 0.7);
          }
        }
      }
    }
  }
  .data_box {
    flex: 0 0 auto;
    margin-bottom: 12px;
    &.box1 {
      width: 230px;
      height: 66px;
    }
    &.box2 {
      width: 230px;
      height: 118px;
    }
    &.box5,
    &.box6 {
      width: 238px;
      height: 130px;
    }
    .icon {
      &.icon_s {
        width: 56px;
        height: 56px;
        margin-left: 16px;
      }
      &.icon_m {
        width: 84px;
        // height: 80px;
        margin-left: 8px;
        p {
          margin-top: 4px;
          text-align: center;
        }
      }
      img {
        display: block;
      }
    }
    .line {
      width: 1px;
      height: 102px;
      opacity: 0.25;
      border: 1px solid;
      border-image: linear-gradient(
          180deg,
          rgba(13, 165, 251, 0.05),
          rgba(33, 61, 222, 0.5),
          rgba(140, 235, 255, 0.55),
          rgba(38, 68, 245, 0.46),
          rgba(13, 169, 254, 0.19)
        )
        1 1;
      margin: 0 3px;
    }
    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      margin-left: 8px;
      .num {
        font-family: Roboto-Medium, Roboto;
        font-size: 20px;
        color: #fff;
        text-shadow: 0px 0px 4px rgba(83, 143, 209, 0.7);
        margin-bottom: 5px;
      }
    }
  }
}
.chart_box {
  width: 480px;
  height: 200px;
}
.card_table {
  height: 180px;
}
</style>
